<template>
  <v-container fluid class="home-background fill-height">
    <v-row>
      <v-col cols="12">
        <div class="mb-8 user">
          <h2 class="font-weight-bold mt-8">
            Hola {{ this.$store.state.usuario.usuario }} 👋
          </h2>
          <div class="subtitle-1">¿Qué te gustaría hacer hoy?</div>
          <h3 class="mt-6">Panel de acciones frecuentes</h3>
        </div>
      </v-col>

      <v-col
        v-for="card in filteredCards"
        :key="card.subtitle"
        cols="12"
        sm="6"
        md="4"
        lg="3"
      >
        <v-card
          class="shortcut-card pa-5 rounded-xl"
          elevation="12"
          dark
          hover
          @click="go(card.route)"
        >
          <v-icon x-large color="rgb(25, 118, 210)">
            {{ card.icon }}
          </v-icon>

          <div class="mt-4 font-weight-bold text-h6">
            {{ card.title }}
          </div>

          <div class="caption mt-1">
            {{ card.subtitle }}
          </div>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import { getDeportesConfig } from "@/utils/models";

export default {
  name: "Login",
  data: () => ({
    cards: [
      {
        key: "agenda-semanal-grilla",
        title: "Agenda semanal",
        subtitle: "Vista por semana",
        icon: "mdi-tablet",
        route: "/turnos/gestion_turnos_wide",
      },
      {
        key: "agenda-semanal-lista",
        title: "Agenda semanal",
        subtitle: "Vista por semana",
        icon: "mdi-cellphone",
        route: "/turnos/gestion_turnos_semana",
      },
      {
        key: "agenda-diaria",
        title: "Agenda diaria",
        subtitle: "Vista por día",
        icon: "mdi-calendar-today",
        route: "/turnos/gestion_turnos",
      },
      {
        title: "Canchas",
        subtitle: "Gestión de canchas",
        icon: "mdi-tennis",
        route: "/gestion/canchas",
      },
      {
        title: "Cronogramas canchas",
        subtitle: "Configure horarios de las canchas",
        icon: "mdi-cogs",
        route: "/gestion/cronogramas",
      },
      {
        title: "Competiciones",
        subtitle: "Gestión de Torneos y Ligas",
        icon: "mdi-trophy-outline",
        route: "/lista-competiciones",
      },
      {
        key: "rankings",
        title: "Rankings",
        subtitle: "Rankings de jugadores",
        icon: "mdi-podium",
        route: "/rankings",
      },
      {
        title: "Jugadores",
        subtitle: "Gestión de jugadores",
        icon: "mdi-account-star-outline",
        route: "/gestion/jugadores",
      },
      {
        title: "Profesores",
        subtitle: "Gestión de profesores",
        icon: "mdi-account-multiple-check",
        route: "/gestion/profesores",
      },
    ],
  }),
  computed: {
    filteredCards() {
      const width = this.$vuetify.breakpoint.width;
      const deportes = getDeportesConfig(
        this.$store.state.usuario.institucion.idInstitucion,
      ).deportes;
      const tieneRol = (id) => this.$store.getters.tieneRol(id);

      return this.cards.filter((card) => {
        if (card.key === "agenda-semanal-grilla")
          return width > 800 && tieneRol(3);
        if (card.key === "agenda-semanal-lista")
          return width <= 800 && tieneRol(3);
        if (card.key === "agenda-diaria") return tieneRol(3);
        if (card.key === "rankings")
          return deportes.some(
            (d) => d.value === "Padel" || d.value === "Tenis",
          );
        if (card.route === "/gestion/canchas") return tieneRol(8);
        if (card.route === "/gestion/cronogramas") return tieneRol(9);
        if (card.route === "/lista-competiciones") return tieneRol(4);
        if (card.route === "/gestion/jugadores") return tieneRol(8);
        if (card.route === "/gestion/profesores") return tieneRol(8);
        return true;
      });
    },
  },
  methods: {
    go(route) {
      this.$router.push(route);
    },
  },
  mounted() {
    window.scrollTo({ top: 0, behavior: "smooth" });
  },
};
</script>
<style scoped>
.user {
  color: #fff;
}
.home-background {
  min-height: 100vh;
  background: linear-gradient(135deg, #0f2027, #203a43, #2c5364);
  padding: 32px;
}

.shortcut-card {
  cursor: pointer;
  height: 180px;
  backdrop-filter: blur(10px);
  background: rgba(20, 35, 45, 0.85);
  border: 1px solid rgba(255, 255, 255, 0.08);
  transition: transform 0.25s ease, box-shadow 0.25s ease;
}

.shortcut-card:hover {
  transform: translateY(-6px);
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.35);
}
.shortcut-card.primary {
  border: 1px solid rgba(0, 255, 156, 0.4);
}
</style>
